module.exports = __webpack_public_path__ + "img/descMask.a88f8c22.png";